import React from "react";
import {SelectField} from "./FilterComponentStyles";
import {useFetch} from "hooks/useFetch";
import {useStore} from "hooks/useStore";

const InvoiceStatusFilter = ({value, onChange}) => {
    const stores = useStore();
    const [invoiceStatusesLoading, invoiceStatuses] = useFetch({
        fetchFn: stores.companyStore.invoiceStatuses.bind(null, {}),
        initialCall: true
    });
    return (
        <SelectField value={value} onChange={onChange}>
            <SelectField.Option value="all">Tümü</SelectField.Option>
            {invoiceStatuses?.map(invoiceStatus => (
                <SelectField.Option key={invoiceStatus?.value} value={invoiceStatus?.value}>
                    {invoiceStatus?.label || "-"}
                </SelectField.Option>
            ))}
        </SelectField>
    );
};

export default InvoiceStatusFilter;
